import { updateUserContact } from '../services/userService'

import types from './types'

const { FETCH_CONTACT_UPDATE } = types

function fetchUpdateContact(data) {
  return dispatch =>
    updateUserContact(data).then(contact => {
      dispatch({
        type: FETCH_CONTACT_UPDATE,
        state: contact
      })
    })
}

export default fetchUpdateContact



// WEBPACK FOOTER //
// ./src/alelo-logic/actions/fetchUpdateContact.js